import type { PresetPassThroughOptions } from '../preset-options'

/** Autocomplete component */
export default {
  autocomplete: {
    root: ({ props }: PresetPassThroughOptions) => ({
      class: [
        'relative inline-flex',
        'w-full',
        {
          'opacity-60 select-none pointer-events-none cursor-default':
            props?.disabled,
        },
      ],
    }),
    pcInputText: {
      root: {
        class: ['pr-10'],
      },
    },
    clearIcon: {
      class: [
        'absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center size-3',
        'text-fp-gray-5 hover:text-fp-gray-6 cursor-pointer rounded hover:bg-fp-gray-1 transition-colors z-10',
      ],
    },
    panel: {
      class: [
        'bg-white border border-fp-gray-2 rounded-md shadow-lg mt-1 max-h-[300px] overflow-auto z-50',
      ],
    },
    overlay: {
      class: [
        'absolute top-0 left-0 rounded-md bg-white border border-fp-gray-2 shadow-lg max-h-[300px] overflow-auto z-50',
      ],
    },
    list: {
      class: 'py-1 m-0 p-1 list-none flex flex-col gap-0.5',
    },
    listContainer: {
      class: 'overflow-auto',
    },
    item: ({ context }: PresetPassThroughOptions) => ({
      class: [
        'px-3 py-2 cursor-pointer transition-colors duration-200',
        context?.focused ? 'bg-primary-0 text-fp-gray-6' : 'text-fp-gray-6',
      ],
    }),
    option: ({ context }: PresetPassThroughOptions) => ({
      class: [
        'px-3 py-2 cursor-pointer transition-colors duration-200 rounded-sm',
        context?.focused
          ? 'bg-primary-0 text-fp-gray-6'
          : 'text-fp-gray-6 bg-transparent border-none',
      ],
    }),
    optionGroup: {
      class: 'm-0 px-3 py-2 text-fp-gray-5 font-semibold bg-transparent',
    },
    emptyMessage: {
      class: ['px-3 py-2 text-fp-gray-5 text-sm'],
    },
    loadingIcon: {
      class: ['text-fp-gray-4 animate-spin w-5 h-5'],
    },
    loader: {
      class: [
        'absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center w-5 h-5',
        'text-fp-gray-4 z-10 pointer-events-none animate-spin',
      ],
    },
  },
}
